import api from '../clients/api';
import { handleUnauthorized } from '../utils/apiWrapper';
import {
  GetConversationsQuery,
  SaveConversationMessageSentimentParams
} from '@kimuno/api-sdk/lib/types/requests/Conversation';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
  saveMessageSentiment,
  getConversations,
  deleteConversation,
  getConversation,
};

function saveMessageSentiment(conversationId: string, payload: SaveConversationMessageSentimentParams) {
  notifyBugsnagNetwork('Conversation', 'saveMessageSentiment', {  ...payload });
  return handleUnauthorized(() => api.conversation.saveConversationMessageSentiment(conversationId, payload));
}

function getConversations(payload: GetConversationsQuery) {
  notifyBugsnagNetwork('Conversation', 'getConversations', {  ...payload });
  return handleUnauthorized(() => api.conversation.getConversations(payload));
}

function deleteConversation(conversationId: string) {
  notifyBugsnagNetwork('Conversation', 'deleteConversation', { conversationId });
  return handleUnauthorized(() => api.conversation.deleteConversation(conversationId));
}

function getConversation(conversationId: string) {
  notifyBugsnagNetwork('Conversation', 'getConversation', { conversationId });
  return handleUnauthorized(() => api.conversation.getConversation(conversationId));
}

export default service;
